<template>
    <div class="row">
        <div class="col-12">
            <b class="d-block mb-1">Exclusive offers and services</b>
            <p class="d-block small m-0">We'd like to keep you informed by email and SMS of our exclusive offers and services.</p>
            <label for="marketing" class="cursor-pointer mt-2 mb-sm-2 mb-sm-3">
                <input type="checkbox" id="marketing" class="cursor-pointer" name="marketing" v-model="denyMarketing" @change="toggleMarketing()">
                <b class="small ps-2">Please tick the box if you do not want to receive any communication about our exclusive offers and services.</b>
            </label>
        </div>
    </div>
</template>

<script>
    import basketFunctions from "@shared/mixins/basket";
    export default {
        mixins: [basketFunctions],
        props: ['basket'],
        data() {
            return {
                updatedBasket: this.basket,
                denyMarketing: (this.basket.marketing == null || this.basket.marketing == '1' ? false : true)
            }
        },
        computed: {
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
            });
        },
        methods: {
            toggleMarketing: function() {
                let vm = this;
                axios.post('/ajax/toggle_marketing/' + (vm.denyMarketing ? 0 : 1))
                .then(response => {
                    vm.updatedBasket = response.data.basket;
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
        }
    };
</script>

<style lang="scss" scoped>

</style>